import React, { useCallback, useState } from 'react';

import { EmojiPicker } from 'Shared/components/EmojiMartComponents';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';
import { usePopover, WpPopoverOverlay } from 'Wpds/components/popover';
import './SidePanelTextEditorEmojiPicker.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  onEmojiAdd: Function;
};

function SidePanelTextEditorEmojiPicker({ onEmojiAdd }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const { tr } = useTranslation();

  const popover = usePopover({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'top',
    showArrow: false,
    withBoxShadow: true,
    withStyling: false,
    withPadding: false,
  });

  const handleToggle = useCallback(() => setIsOpen(prevState => !prevState), []);

  const handleEmojiClick = useCallback(
    gif => {
      setIsOpen(false);
      onEmojiAdd(gif);
    },
    [onEmojiAdd]
  );

  return (
    <>
      <WpTooltip>
        <WpTooltipTrigger>
          <WpButton variant="tertiary" size="sm" ref={popover.targetRef} onClick={handleToggle}>
            <WpIcon name="smile" />
          </WpButton>
        </WpTooltipTrigger>
        {!isOpen && <WpTooltipContent>{tr('perform.common.editor.add_emoji')}</WpTooltipContent>}
      </WpTooltip>
      <WpPopoverOverlay context={popover}>
        <EmojiPicker
          onSelect={handleEmojiClick}
          title={tr('perform.common.editor.emoji_picker_title')}
          emoji="point_up"
        />
      </WpPopoverOverlay>
    </>
  );
}

export default SidePanelTextEditorEmojiPicker;
